import clsx from "clsx";
import { ComponentPropsWithRef, forwardRef, ReactNode } from "react";
import PillStyle from "./css/Pill.module.css";
import colorToRgba from "../utils/colorToRgba";
import transWidthHeight from "./utils/transWidthHeight";

type PillProps = ComponentPropsWithRef<"div"> & {
    text: ReactNode;
    variant?: "black" | "gray" | "white";
    icon?: React.ReactNode;
    iconPosition?: "left" | "right";
    border?: number;
    padding?: number;
    paddingX?: number;
    paddingY?: number;
    paddingLeft?: number;
    paddingRight?: number;
    paddingTop?: number;
    paddingBottom?: number;
    backgroundColor?: string;
    width?: number | string;
    height?: number | string;
    color?: string;
};
const Pill = forwardRef<HTMLDivElement, PillProps>(({
    text,
    variant = "white",
    border = 1,
    icon,
    iconPosition = "left",
    width,
    height,
    color,
    padding,
    paddingX,
    paddingY,
    paddingLeft,
    paddingRight,
    paddingTop,
    paddingBottom,
    backgroundColor,
    style, className, ...props }, ref) => {
    const colorValue = color ? colorToRgba(color, 1) : variant;
    const borderValue = border ? `${border}px solid rgba(221, 221, 221, 1)` : "none";
    const paddingLeftValue = paddingLeft ? paddingLeft : paddingX ?? padding;
    const paddingRightValue = paddingRight ? paddingRight : paddingX ?? padding;
    const paddingTopValue = paddingTop ? paddingTop : paddingY ?? padding;
    const paddingBottomValue = paddingBottom ? paddingBottom : paddingY ?? padding;
    const widthValue = transWidthHeight(width);
    const heightValue = transWidthHeight(height);
    return (
        <div 
            ref={ref}
            className={clsx(
                PillStyle.pill,
                PillStyle[variant],
                PillStyle[`icon-${iconPosition}`],
                className
            )}
            style={{
                border: borderValue,
                width: widthValue,
                height: heightValue,
                backgroundColor: backgroundColor ? backgroundColor : colorValue,
                paddingLeft: paddingLeftValue && `${paddingLeftValue}px`,
                paddingRight: paddingRightValue && `${paddingRightValue}px`,
                paddingTop: paddingTopValue && `${paddingTopValue}px`,
                paddingBottom: paddingBottomValue && `${paddingBottomValue}px`,
                ...style
            }}
            {...props}>
            {icon}
            {text}
        </div>
    )
});

Pill.displayName = "Pill";

export default Pill;